<!-- 位置提示组件 -->
<template>
    <div class="tip">
        <img
            class="icon"
            src="./../../assets/img/law/question.svg"
            @click="isShow = true"
        />
        <veui-dialog
            overlay-class="position-tip"
            :title="name + '示例'"
            :open.sync="isShow"
            :footless="true"
            :closable="false"
        >
            <template #title>
                <div class="title-box">
                    <div class="main-title">
                        {{ name }}示例
                    </div>
                    <div class="sub-title">
                        您填写的信息将在页面当前位置显示
                    </div>
                </div>
            </template>
            <div class="close-btn" @click="isShow = false">
            </div>
            <img
                :src="demoPic"
                alt=""
                class="demo-pic"
            >
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file tip.vue
 * @author dingzhenyue
 * @desc 位置提示弹窗
 */
import {Dialog} from 'veui';

export default {
    name: 'positionTip',
    data() {
        return {
            // 是否展示
            isShow: false
        };
    },
    props: {
        // 示例名称
        name: {
            'type': String,
            'default': ''
        },
        // 展示图片
        demoPic: {
            'type': String,
            'default': ''
        }
    },
    components: {
        'veui-dialog': Dialog
    }
};
</script>

<style lang='less' scoped>
    .tip {
        .icon {
            cursor: pointer;
        }
    }
</style>
<style lang="less">
    .position-tip {
        .veui-dialog-content {
            background-color: transparent;
            box-shadow: none;
            width: auto;
        }

        .veui-dialog-content-body {
            position: relative;
            overflow: hidden;
        }

        .title-box {
            font-family: PingFangSC-Medium;
            text-align: center;
            color: #fff;
            font-weight: 500;
            margin: 0 auto;

            .main-title {
                font-size: 28px;
                line-height: 28px;
            }

            .sub-title {
                font-size: 18px;
                line-height: 18px;
                margin-top: 13px;
            }
        }

        .close-btn {
            position: absolute;
            top: 0;
            right: 0;
            height: 30px;
            width: 30px;
            background: url(https://lvlin-base.cdn.bcebos.com/bend/close-icon.png) no-repeat center center / 100% 100%;
            cursor: pointer;
        }

        .demo-pic {
            height: 722px;
        }
    }
</style>
